import { call, put, takeLeading, select, takeEvery, takeLatest } from "redux-saga/effects";
import {
  sendOTP as sendOTPBuy,
  sendOTPSuccess as sendOtpBuySuccess,
  sendOTPFailure as sendOtpBuyFailure,
  submit as submitBuy,
  submitSuccess as submitBuySuccess,
  submitFailure as submitBuyFailure,
  getRedeemAccount as getRedeemAccountBuy,
  getRedeemAccountSuccess as getRedeemAccountBuySuccess,
  getRedeemAccountFailure as getRedeemAccountBuyFailure,
  initialBuyFund,
  inquirySuitabilitySuccess as inquirySuitabilityBuySuccess,
  inquirySuitabilityFailure as inquirySuitabilityBuyFailure,
  gotoFundPage as gotoInitialPageBuy,
} from "redux/reducers/buy-sell-switching/buy-fund";
import {
  getAssetKcus as getAssetKcuSell,
  getAssetKcusSuccess as getAssetKcusSellSuccess,
  getAssetKcusFailure as getAssetKcusSellFailure,
  sendOTP as sendOTPSell,
  sendOTPSuccess as sendOtpSellSuccess,
  sendOTPFailure as sendOtpSellFailure,
  submit as submitSell,
  submitSuccess as submitSelSuccess,
  submitFailure as submitSellFailure,
  getRedeemAccount as getRedeemAccountSell,
  getRedeemAccountSuccess as getRedeemAccountSellSuccess,
  getRedeemAccountFailure as getRedeemAccountSellFailure,
  gotoInitialPage as gotoInitialPageSell,
} from "redux/reducers/buy-sell-switching/sell-fund";
import {
  getAssetKcus as getAssetKcusSwitch,
  getAssetKcusSuccess as getAssetKcusSwitchSuccess,
  getAssetKcusFailure as getAssetKcusSwitchFailure,
  sendOTP as sendOTPSwitch,
  sendOTPSuccess as sendOTPSwitchSuccess,
  sendOTPFailure as sendOTPSwitchFailure,
  submit as submitSwitch,
  submitSuccess as submitSwitchSuccess,
  submitFailure as submitSwitchFailure,
  fetchAvailableSwitchFunds,
  fetchAvailableSwitchFundsSuccess,
  fetchAvailableSwitchFundsFailure,
  initialSwitchFund,
  inquirySuitabilitySuccess as inquirySuitabilitySwitchSuccess,
  inquirySuitabilityFailure as inquirySuitabilitySwitchFailure,
  gotoInitialPage as gotoInitialPageSwitch,
} from "redux/reducers/buy-sell-switching/switch-fund";
import {
  getFundById,
  getFundByIdFailure,
  getFundByIdSuccess,
  getFundList,
  getFundListFailure,
  getFundListSuccess,
  cancelFetchFund,
} from "redux/reducers/ultrahigh-constant";
import { UltrahighConstSelector } from "redux/selector/ultrahigh-constant-selector";
import { BuySellSwitchAPI } from "services/buy-sell-switching";
import { convertArrayToObject, isNotNullish } from "utils/common-util";
import { CommonAPI } from "services/common";
import find from "lodash/find";
import {
  cancelTrans,
  cancelTransFailure,
  cancelTransSuccess,
  fetchFundTrans,
  fetchFundTransFailure,
  fetchFundTransSuccess,
  fetchRetrospectiveTrans,
  fetchRetrospectiveTransFailure,
  fetchRetrospectiveTransSuccess,
  fetchRetrospectiveTransStatus,
  fetchAllData,
  fetchSwitchData,
  fetchSellData,
  fetchBuyData,
} from "redux/reducers/buy-sell-switching/transaction-fund";
import { SwitchFundSelector, TransactionFundSelector } from "redux/selector/buy-sell-switching-selector";
import { CustomerAPI } from "services/customer";
import { AcceptType, ErrorType, FundTransactionType } from "const";
import { openModal } from "redux/reducers/central-modal";
import { handleClientError } from "utils/saga-error";
import { isSystemCloseError } from "const/const-helper";

const initialSaga = function* ({ type, payload }) {
  // risk level
  const { inquirySuitability } = getProviderByActionType(type);
  try {
    const response = yield call(CustomerAPI.getSuitabilityData);
    const data = response.data.result;
    yield put(
      inquirySuitability.success({
        riskUserProfileLevel: data.suitable,
        exchangeRateFlag: data.exchangeRateFlag,
      })
    );
  } catch (error) {
    yield put(inquirySuitability.failure(handleClientError(error)));
  }
};

const getRedeemAccountSaga = function* ({ type, payload }) {
  const { getRedeemAccount } = getProviderByActionType(type);
  try {
    const response = yield call(BuySellSwitchAPI.getRedeemAccount, payload);
    yield put(getRedeemAccount.success({ redeemAccount: response.data.result }));
  } catch (error) {
    yield put(getRedeemAccount.failure(handleClientError(error)));
  }
};

const getFundListSaga = function* (action) {
  try {
    const fundList = yield select(UltrahighConstSelector.fundList);
    const currentFundType = yield select(UltrahighConstSelector.fundType);
    const fetchYet = !fundList || fundList.length === 0;
    const changeFundType = currentFundType !== action.payload.type;
    if (fetchYet || changeFundType) {
      const response = yield call(BuySellSwitchAPI.getFundList, action.payload);
      yield put(getFundListSuccess(response.data.result.funds ?? []));
    } else {
      yield put(cancelFetchFund());
    }
  } catch (error) {
    if (isSystemCloseError(error?.code)) {
      yield put(getFundListSuccess([]));
    }

    yield put(getFundListFailure(error));
  }
};

const getFundByIdSaga = function* (action) {
  const fundId = action.payload;
  try {
    if (isNotNullish(fundId)) {
      const fundDetails = yield select(UltrahighConstSelector.fundDetails);
      if (!fundDetails[action.payload].detail) {
        const response = yield call(BuySellSwitchAPI.getFundById, { fundId });
        const detail = response.data.result;
        yield put(getFundByIdSuccess({ fundId, detail }));
      } else {
        yield put(getFundByIdSuccess({ fundId, detail: fundDetails[action.payload].detail }));
      }
    }
  } catch (error) {
    yield put(getFundByIdFailure(handleClientError(error)));
  }
};

const sendOTPSaga = function* (action) {
  const { sendOTP } = getProviderByActionType(action.type);
  try {
    const response = yield call(CommonAPI.sendOTP, action.payload);
    yield put(sendOTP.success(response.data.result));
  } catch (error) {
    yield put(sendOTP.failure(handleClientError(error)));
  }
};

const submitSaga = function* (action) {
  const { submit } = getProviderByActionType(action.type);
  try {
    const response = yield call(submit.api, action.payload);
    yield put(submit.success(response.data.result));
  } catch (error) {
    const errorCutOffTime = error.code === ErrorType.CUT_OFF_TIME_REQUIRE_ACCEPT;
    if (errorCutOffTime) yield put(submit.gotoFirstStep());
    yield put(submit.failure(handleClientError(error)));
  }
};

const getAssetKcusSaga = function* ({ type }) {
  const { getAssetKcus } = getProviderByActionType(type);
  try {
    const response = yield call(BuySellSwitchAPI.getAssetKcus);
    const assetKcus = convertArrayToObject(response.data.result.uhmfList, "uhmfId");
    Object.entries(assetKcus).forEach(([uhmfId, { funds }]) => {
      funds.forEach((fund) => (fund.uhmfId = uhmfId));
    });
    yield put(getAssetKcus.success(assetKcus));
  } catch (error) {
    yield put(getAssetKcus.failure(handleClientError(error)));
  }
};

const fetchAvailableSwitchFundsSaga = function* ({ payload }) {
  try {
    const fundList = yield select(UltrahighConstSelector.fundList);
    const fund = find(fundList, { fundId: payload.fundId });
    const availableSwitchFundsTemp = yield select(SwitchFundSelector.availableSwitchFundsTemp);
    if (!availableSwitchFundsTemp[fund.fundId]?.data) {
      const response = yield call(BuySellSwitchAPI.fetchAvailableSwitchFunds, { fundAbbr: fund.fundAbbr });
      yield put(
        fetchAvailableSwitchFundsSuccess({
          fundId: payload.fundId,
          funds: response.data.result.funds,
        })
      );
    }
  } catch (error) {
    yield put(fetchAvailableSwitchFundsFailure({ fundId: payload.fundId, ...error }));
  }
};

const fetchFundTransSaga = function* ({ payload }) {
  try {
    const response = yield call(BuySellSwitchAPI.fetchFundTransaction, payload);
    const { currentTime, histories } = response.data.result;
    const holdingTrans = [];
    histories.forEach((history) => {
      histories.serverTime = currentTime;
      if ("PH".includes(history.transactionStatus)) {
        holdingTrans.push(history);
      }
    });
    yield put(fetchFundTransSuccess({ holdingTrans }));
  } catch (error) {
    yield put(fetchFundTransFailure(handleClientError(error)));
  }
};
const fetchRetrospectiveCenterSaga = function* ({ payload }) {
  yield put(fetchRetrospectiveTrans(payload));
};

const fetchRetrospectiveTransSaga = function* ({ payload }) {
  try {
    const transactionType = payload.transactionType;
    const retrosTrans = yield select(TransactionFundSelector.retrospectiveTrans);
    const sourceData = getSourceData(transactionType, retrosTrans);

    // do not fetch anything when change tabs or max page, except initial load
    const isNotInitialPageLoad = sourceData?.transaction.length > 0;
    const { rowPerPage, total, page } = sourceData.pagination;
    const requiredPage = page + (payload.isLoadMore ? 1 : 0);
    const isOutOfPaging = isNotNullish(total) && requiredPage > Math.ceil(total / rowPerPage);
    if ((payload.isTranTypeChange && isNotInitialPageLoad) || isOutOfPaging) return;

    yield put(fetchRetrospectiveTransStatus({ transactionType, loading: true }));
    const requestPayload = {
      ...payload,
      page: requiredPage,
      rowPerPage: rowPerPage,
    };
    delete requestPayload.isTranTypeChange;
    const response = yield call(BuySellSwitchAPI.fetchRetrospectiveTransaction, requestPayload);
    const { pageIndex, total: rTotal, histories: transaction } = response.data.result;
    const successPayload = { transaction, transactionType, total: rTotal, page: pageIndex };
    yield put(fetchRetrospectiveTransSuccess(successPayload));
  } catch (error) {
    yield put(fetchRetrospectiveTransFailure(handleClientError(error)));
  }
};

const onCancelFundTransSaga = function* ({ payload }) {
  const transactionNo = payload;
  try {
    const response = yield call(BuySellSwitchAPI.cancelFund, { transactionNo });
    yield put(cancelTransSuccess(response.data.result));
    const payloadModal = {
      code: AcceptType.PwmRegisterInfo,
      state: { messageCode: "pwm.bss.trans.cancel.success", showIcon: true },
    };
    yield put(openModal(payloadModal));
  } catch (error) {
    yield put(cancelTransFailure(handleClientError(error)));
  }
};

const buyProvider = {
  getRedeemAccount: {
    api: BuySellSwitchAPI.getRedeemAccount,
    success: getRedeemAccountBuySuccess,
    failure: getRedeemAccountBuyFailure,
  },
  submit: {
    api: BuySellSwitchAPI.buyFund,
    success: submitBuySuccess,
    failure: submitBuyFailure,
    gotoFirstStep: gotoInitialPageBuy,
  },
  sendOTP: {
    success: sendOtpBuySuccess,
    failure: sendOtpBuyFailure,
  },
  inquirySuitability: {
    success: inquirySuitabilityBuySuccess,
    failure: inquirySuitabilityBuyFailure,
  },
};

const sellProvider = {
  getRedeemAccount: {
    api: BuySellSwitchAPI.getRedeemAccount,
    success: getRedeemAccountSellSuccess,
    failure: getRedeemAccountSellFailure,
  },
  submit: {
    api: BuySellSwitchAPI.sellFund,
    success: submitSelSuccess,
    failure: submitSellFailure,
    gotoFirstStep: gotoInitialPageSell,
  },
  sendOTP: {
    success: sendOtpSellSuccess,
    failure: sendOtpSellFailure,
  },
  getAssetKcus: {
    success: getAssetKcusSellSuccess,
    failure: getAssetKcusSellFailure,
  },
};

const switchProvider = {
  submit: {
    api: BuySellSwitchAPI.switchFund,
    success: submitSwitchSuccess,
    failure: submitSwitchFailure,
    gotoFirstStep: gotoInitialPageSwitch,
  },
  sendOTP: {
    success: sendOTPSwitchSuccess,
    failure: sendOTPSwitchFailure,
  },
  getAssetKcus: {
    success: getAssetKcusSwitchSuccess,
    failure: getAssetKcusSwitchFailure,
  },
  inquirySuitability: {
    success: inquirySuitabilitySwitchSuccess,
    failure: inquirySuitabilitySwitchFailure,
  },
};

const Providers = {
  buy: buyProvider,
  sell: sellProvider,
  switch: switchProvider,
};

const getProviderByActionType = (type) => Providers[type.split("/")[0]];

const saga = [
  takeLeading([initialBuyFund.type, initialSwitchFund.type], initialSaga),
  takeLeading(getFundList.type, getFundListSaga),
  takeEvery(getFundById.type, getFundByIdSaga),
  takeLeading([sendOTPBuy.type, sendOTPSell.type, sendOTPSwitch.type], sendOTPSaga),
  takeLeading([submitBuy.type, submitSell.type, submitSwitch.type], submitSaga),
  takeLeading([getAssetKcuSell.type, getAssetKcusSwitch.type], getAssetKcusSaga),
  takeLatest([getRedeemAccountBuy.type, getRedeemAccountSell.type], getRedeemAccountSaga),
  takeLeading(fetchFundTrans.type, fetchFundTransSaga),
  takeLeading(fetchAllData.type, fetchRetrospectiveCenterSaga),
  takeLeading(fetchBuyData.type, fetchRetrospectiveCenterSaga),
  takeLeading(fetchSellData.type, fetchRetrospectiveCenterSaga),
  takeLeading(fetchSwitchData.type, fetchRetrospectiveCenterSaga),
  takeEvery(fetchRetrospectiveTrans.type, fetchRetrospectiveTransSaga),
  takeEvery(fetchAvailableSwitchFunds.type, fetchAvailableSwitchFundsSaga),
  takeLatest(cancelTrans.type, onCancelFundTransSaga),
];

export default saga;

function getSourceData(transactionType, retrosTrans) {
  let sourceData;
  switch (transactionType) {
    case FundTransactionType.Buy:
      sourceData = retrosTrans.buyData;
      break;
    case FundTransactionType.Sell:
      sourceData = retrosTrans.sellData;
      break;
    case FundTransactionType.Switch:
      sourceData = retrosTrans.switchData;
      break;
    default:
      sourceData = retrosTrans.allData;
      break;
  }
  return sourceData;
}
